/** Fixed app header height (matches Header Toolbar) */
export const APP_HEADER_HEIGHT = 88
